import { combineReducers } from "redux";
import {
    MessengerWidget,
    ReportTotalBarChartWidget,
    ReportTotalDetailWidget,
    UserReportTotalWidget,
    ReportMapWidget,
    NewsBroadcastWidget,
    NewsBroadcastV2Widget,
    BuildExcelDocWidget,
    BuildVersionWidget,
    UserTotalWidget,
    JobPackTotalWidget,
    ReportTotalWidget,
    ActivityLogWidget,
    JobPackMapWidget,
} from "../../../widgets";
export default combineReducers({
    [ReportMapWidget.reducer_key]: ReportMapWidget.reducer,
    [ActivityLogWidget.reducer_key]: ActivityLogWidget.reducer,
    [MessengerWidget.reducer_key]: MessengerWidget.reducer,
    [JobPackMapWidget.reducer_key]: JobPackMapWidget.reducer,
    [NewsBroadcastWidget.reducer_key]: NewsBroadcastWidget.reducer,
    [NewsBroadcastV2Widget.reducer_key]: NewsBroadcastV2Widget.reducer,
    [ReportTotalBarChartWidget.reducer_key]: ReportTotalBarChartWidget.reducer,
    [ReportTotalDetailWidget.reducer_key]: ReportTotalDetailWidget.reducer,
    [UserReportTotalWidget.reducer_key]: UserReportTotalWidget.reducer,
    [BuildExcelDocWidget.reducer_key]: BuildExcelDocWidget.reducer,
    [UserTotalWidget.reducer_key]: UserTotalWidget.reducer,
    [JobPackTotalWidget.reducer_key]: JobPackTotalWidget.reducer,
    [ReportTotalWidget.reducer_key]: ReportTotalWidget.reducer,
    [BuildVersionWidget.reducer_key]: BuildVersionWidget.reducer,
});
